"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _table = _interopRequireDefault(require("./table"));

var _tableSeparator = _interopRequireDefault(require("./tableSeparator"));

var _Error = _interopRequireDefault(require("../Error"));

var TableGrouped =
/*#__PURE__*/
function (_Table) {
  (0, _inherits2.default)(TableGrouped, _Table);

  function TableGrouped() {
    (0, _classCallCheck2.default)(this, TableGrouped);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TableGrouped).apply(this, arguments));
  }

  (0, _createClass2.default)(TableGrouped, [{
    key: "renderRows",
    value: function renderRows() {
      var _this = this;

      var _this$props = this.props,
          rows = _this$props.rows,
          separatorCallback = _this$props.separatorCallback,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["rows", "separatorCallback"]);

      if (!rows || rows.length === 0) {
        return _react.default.createElement(_Error.default, {
          title: this.getEmptyMessage()
        });
      }

      var groups = rows.reduce(function (groups, row) {
        var group = separatorCallback(row);

        if (!groups.hasOwnProperty(group)) {
          groups[group] = [row];
          return groups;
        }

        groups[group].push(row);
        return groups;
      }, {});
      var idx = 0;
      return Object.keys(groups).reduce(function (result, group, index) {
        var header = _react.default.createElement(_tableSeparator.default, {
          key: "separator".concat(index)
        }, group);

        var rows = groups[group].map(function (row) {
          return _this.renderRow(row, idx++, props);
        });
        return (0, _toConsumableArray2.default)(result).concat([header, _react.default.createElement("div", {
          className: "table-content",
          key: "group".concat(index)
        }, rows)]);
      }, []);
    }
  }]);
  return TableGrouped;
}(_table.default);

exports.default = TableGrouped;
(0, _defineProperty2.default)(TableGrouped, "propTypes", {
  separatorCallback: _propTypes.default.func.isRequired,
  rows: _propTypes.default.arrayOf(_propTypes.default.object)
});